const ServerConfiguration = require("common/ServerConfiguration");

const BrowserNavigationHistory = function() {
    let savedHistory;
    let savedConfig;
    let savedSession;
    let navManager;

    $(document).on("appinit", function() {
        // Retrieve from session storage any previously saved state
        savedHistory = sessionStorage.getObject("history");
        savedConfig = sessionStorage.getObject("serverConfig");
        savedSession = sessionStorage.getObject("session");

        delete sessionStorage.history;
        delete sessionStorage.serverConfig;
        delete sessionStorage.session;
    });

    $(document).on("restorestate", function() {
        navManager = CudaLaunch.navManager;

        // If we are trying to go somewhere inside the app
        if (window.location.hash && window.location.hash.length > 0) {
            // Before we start to use the app, reset the saved state
            if (savedHistory) {
                $.mobile.navigate.history.stack = savedHistory.history;
                $.mobile.navigate.history.activeIndex = savedHistory.activeIndex;
                $.mobile.navigate.history.previousIndex = savedHistory.previousIndex;
            }

            // Don't restore the server config if we are/were on the logon page
            if (savedConfig && window.location.hash !== "#Logon") {
                CudaLaunch.serverConfiguration = new ServerConfiguration(savedConfig);

                $.event.trigger("initialiseServerPaths");

                if (savedSession) {
                    CudaLaunch.serverConfiguration.setSession(savedSession);

                    if (savedSession.username) {
                        $.event.trigger("userauthenticated", [savedSession]);
                    }
                }
            }

            console.info("Page reloaded - log has been reset");
            $.event.trigger("staterestored", [CudaLaunch.serverConfiguration]);
        } else {
            $.event.trigger("staterestored");
        }
    });

    function storeHistory() {
        if (CudaLaunch.serverConfiguration) {
            sessionStorage.setObject("serverConfig", CudaLaunch.serverConfiguration);

            if (CudaLaunch.serverConfiguration.getSession()) {
                sessionStorage.setObject("session", CudaLaunch.serverConfiguration.getSession());
            }
        }
        sessionStorage.setObject("history", {
            history : $.mobile.navigate.history.stack,
            activeIndex : $.mobile.navigate.history.activeIndex,
            previousIndex : $.mobile.navigate.history.previousIndex
        });
    }

    // Some browsers (i.e. mobile safari) don't fire unload events so we need to also listen for pagehide
    $(window).on("beforeunload", storeHistory);
    window.addEventListener("pagehide", storeHistory, false);
};

module.exports = BrowserNavigationHistory;